import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Icon = styled.div<{ open?: boolean }>`
  position: absolute;
  right: 12px;
  top: 12px;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  transform-origin: center;
  height: 24px;
  width: 24px;
  transition: transform 0.2s ease-in-out;
  pointer-events: none;
`;

export const SelectBox = styled.select<{ error?: string }>`
  // Reset
  appearance: none;
  border: none;
  margin: 0;
  width: 100%;
  font-family: inherit;
  cursor: pointer;
  line-height: inherit;
  outline: none;

  // Own
  height: 48px;
  background-color: var(--colorBlueGray50);
  border-radius: 4px;
  border: 1px solid ${({ error }) => (error ? 'var(--colorWarning)' : 'rgb(213, 215, 216)')};
  padding: 7px 16px 9px;
  font-size: 14px;
  font-weight: 600;

  &:focus {
    border-color: var(--colorBlueGray1200) !important;
  }
`;
